import { isNullOrUndefinedOrBlank } from "./isNullOrUndefinedOrBlank";
import { IListing } from '../models/listing.model';

export const formatListingCommunityName = (listing: IListing) => {
  let text = '';
  if (!isNullOrUndefinedOrBlank(listing.community)) {
    text += listing.community;
    text += ', ';
  }
  if (!isNullOrUndefinedOrBlank(listing.city)) {
    text += listing.city;
  }
  if (!isNullOrUndefinedOrBlank(listing.state)) {
    text += ', ' + listing.state;
  }
  return text;
};

export const formatListingPropertyType = (propType: string) => {
  switch (propType) {
    case 'Detached': {
      return 'Detached House';
    }
    case 'Semi-detached': {
      return 'Semi-detached House';
    }
    case 'Condo': {
      return 'Condominium';
    }
    case 'Att/row/twnhouse': {
      return 'Townhouse';
    }
    default: {
      return propType;
    }
  }
};

export const formatListingType = (listing: IListing) => {
  let text = '';
  if (!isNullOrUndefinedOrBlank(listing.propType)) {
    text += formatListingPropertyType(listing.propType);
    text += ' ';
  }
  if (!isNullOrUndefinedOrBlank(listing.saleOrLease)) {
    text += formatForSaleOrLease(listing.saleOrLease);
    text += ' ';
  }
  return text;
};

export const formatForSaleOrLease = (saleOrLease: string) => {
  return saleOrLease === 'lease'
    ? 'For Lease'
    : 'For Sale'
};
